<template>
  <div id="app">
    <p-header></p-header>
    <sub-menu></sub-menu>
    <router-view class="page-main-body" v-if="$route.path" />
    <horizontal-hint></horizontal-hint>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import PHeader from './views/common/_header.vue';
import subMenu from './views/common/_sub-menu.vue';
import horizontalHint from './views/common/_horizontal.vue';

export default {
  name: 'page-main',
  components: {
    PHeader,
    subMenu,
    horizontalHint,
  },
  data() {
    return {
      isRouteAlive: true,
    };
  },
  watch: {
    $route() {
      this.$store.state.subMeunSwitch = false;
    },
  },
  updated() {
    const that = this;
    that.$nextTick(() => {
      // that.isRouteAlive = false;
      that.pageInit();
    });
  },
  mounted() {
    // this.getCategories();
    this.$root.$on('notifyScrollShow', () => {
      this.pageInit();
    });
  },
  methods: {
    ...mapActions(['getCategories']),
    reload() {
      this.isRouteAlive = false;
      this.$nextTick(() => {
        this.isRouteAlive = true;
      });
    },
  },
};
</script>
